import React, { Component } from 'react';
import HomeNav from './HomeNav';
import Loading from './Loading';

class FounderFriday extends Component {

  render() {
    return (
      <div className="home-page founder-friday">
        <HomeNav />
        <div>
          <div>
            <div className="banner bg-img">
              <div className="contain" />
            </div>
          </div>
        </div>
        <div className="founder-friday-wrapper">
          <iframe src={`https://docs.google.com/forms/d/e/1FAIpQLSflv6AXSgVeqpv3d4fR5iM9pCvGg_4VgPZRryGmNxT2gpMumw/viewform?embedded=true`} title='Founders Friday' width="100%" height="1500px">
          <div className="content payment-loader">
                <Loading/>
              </div>
          </iframe>
        </div>
      </div>
    );
  }
}

export default FounderFriday;



// WEBPACK FOOTER //
// ./src/components/FounderFriday.js